module.exports = __webpack_public_path__ + "static/media/atul.ea9309f8.jpg";